// document.addEventListener("DOMContentLoaded", () => {
//   const navigation = document.querySelector(".custom-navigation");

//   if (!navigation) return;

//   navigation.addEventListener("click", function (e) {
//     const toggle = e.target.closest(".nav-toggle");

//     if (!toggle) return;

//     e.preventDefault();

//     const navItem = toggle.closest(".nav-item");
//     const submenu = navItem.querySelector(":scope > .submenu");

//     if (!submenu) return;

//     const isOpen = navItem.classList.contains("is-open");

//     // Close siblings
//     const siblings = navItem.parentElement.querySelectorAll(":scope > .nav-item.is-open");

//     siblings.forEach((item) => {
//       if (item !== navItem) {
//         item.classList.remove("is-open");

//         const btn = item.querySelector(":scope > .nav-toggle");
//         const panel = item.querySelector(":scope > .submenu");

//         if (btn) btn.setAttribute("aria-expanded", "false");

//         if (panel) {
//           panel.style.maxHeight = null;
//           panel.hidden = true;
//         }
//       }
//     });

//     if (isOpen) {
//       navItem.classList.remove("is-open");
//       toggle.setAttribute("aria-expanded", "false");

//       submenu.style.maxHeight = null;

//       setTimeout(() => {
//         submenu.hidden = true;
//       }, 300);

//     } else {
//       navItem.classList.add("is-open");
//       toggle.setAttribute("aria-expanded", "true");

//       submenu.hidden = false;

//       submenu.style.maxHeight = submenu.scrollHeight + "px";
//     }
//   });
// });


document.addEventListener("DOMContentLoaded", () => {

  const navigation = document.querySelector(".custom-navigation");

  if (!navigation) return;

  navigation.addEventListener("click", function (e) {

    const button = e.target.closest(".nav-toggle");

    if (!button) return;

    e.preventDefault();

    const item = button.closest(".nav-item");

    const parent = item.parentElement;

parent.querySelectorAll(":scope > .nav-item.is-open").forEach((sibling) => {

  if (sibling !== item) {

    sibling.classList.remove("is-open");
    sibling.querySelector(":scope > .nav-toggle")?.setAttribute("aria-expanded", "false");


    sibling.querySelectorAll(".nav-item.is-open").forEach(child => {
      child.classList.remove("is-open");
      child.querySelector(":scope > .nav-toggle")?.setAttribute("aria-expanded", "false");
    });

  }

});

    item.classList.toggle("is-open");

    button.setAttribute(
      "aria-expanded",
      item.classList.contains("is-open")
    );
    if (!item.classList.contains("is-open")) {
  item.querySelectorAll(".nav-item.is-open").forEach(child => {
    child.classList.remove("is-open");
    child.querySelector(".nav-toggle")?.setAttribute("aria-expanded", "false");
  });
}

  });

});

document.querySelectorAll('.custom-navigation__list > li.has-children').forEach(item => {
    const ul = item.querySelector(':scope > div > ul');
    if (ul) {
        ul.classList.add('first-level-ul');
    }
});